import { EboObject } from './ebo-object';

export abstract class EboNameObject extends EboObject {
  name: string;
}
